import { NgModule } from '@angular/core';

import { SearchAreaService } from './services/SearchArea.service';

@NgModule({
  providers: [],
})
export class SearchProvidersModule {}
